import styled from 'styled-components';

import { Color } from '../../../constants/Colors';
import { Indexes, Shadow } from '../../../constants/Styles';
import { Typography } from '../../../constants/Typographies';

export const Modal = styled.div`
  background-color: ${Color.WATER_LINK};
  color: ${Color.CLOUD_BURST};

  position: fixed;
  bottom: 0;
  right: 0;
  max-width: 400px;
  width: 90%;
  margin: 20px;
  border-radius: 18px;
  box-shadow: ${Shadow.DEEP_BOX_ACTIVE};

  font-size: 12px;
  line-height: 1.5em;

  box-sizing: border-box;
  padding: 1em 1.8em;

  overflow: auto;
  z-index: ${Indexes.COOKIE};

  & > :first-child {
    margin-bottom: 25px;
  }

  @media screen and (max-width: 414px) and (orientation: portrait),
    screen and (max-width: 736px) and (orientation: landscape) {
    max-height: 90vh;
  }

  @media print {
    display: none;
  }
`;

export const CustomizationContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`;

export const SwitchesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 25px 0;
`;

export const Switch = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-grow: 1;
  margin: 7.5px 0 7.5px 5px;
`;

export const SwitchDescription = styled.p`
  ${Typography.M};
  color: ${Color.DOLPHIN};
  padding-left: 10px;
  font-weight: 700;
`;

export const SwitchInfo = styled.p`
  ${Typography.XS};
  color: ${Color.DOLPHIN};
`;

export const CustomizationButtonWrapper = styled.div`
  display: flex;

  button {
    margin: 0 7.5px;
    width: 100%;
    display: block;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  width: 100%;
  padding-top: 20px;

  button {
    margin: 5px 0;
    width: 100%;
    display: block;
  }
`;
